<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10" offset="1">
        <v-row>
          <v-col lg="6" sm="12">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              :disabled="loading"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  label="Начало периода"
                  persistent-hint
                  prepend-icon="mdi-calendar-range-outline"
                  :disabled="loading"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate" no-title @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="6" sm="12">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
              :disabled="loading"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :disabled="loading"
                  v-model="endDate"
                  label="Конец периода"
                  persistent-hint
                  prepend-icon="mdi-calendar-range-outline"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :max="$moment().add(-1, 'days').format('YYYY-MM-DD')"
                v-model="endDate"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <div class="title">{{ $attrs.site_title }}</div>
        <LineChart v-if="!dataIsEmpty" :chart-data="chartData"></LineChart>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LineChart from '@/components/charts/LineChart'
import isEmpty from 'lodash/isEmpty'

import moment from 'moment'
import user from '@/mixins/user'
import { getSitesMetrikaHTMLResponse, getSitesMetrikaResponse } from '@/api/referenece'
import { getDateRange } from '@/utils/dates'
import colors from 'vuetify/lib/util/colors'
import { average } from '@/utils/arrays'

export default {
  name: 'metrika',
  components: {
    LineChart,
  },
  mixins: [user],
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      startDate: moment().add(-7, 'days').format('YYYY-MM-DD'),
      endDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
      page: '',
      metrikaData: null,
      chartData: {},
      chartHTML: '',
      iframeSrc: 'data:text/html;charset=utf-8',
    }
  },
  computed: {
    dataIsEmpty() {
      return isEmpty(this.chartData)
    },
    currentDateRange() {
      return getDateRange(this.$moment(this.startDate), this.$moment(this.endDate))
    },
    chartLabels() {
      return this.currentDateRange.map((x) => {
        return x.format('LL')
      })
    },
  },
  watch: {
    startDate() {
      this.getMetrikaData()
    },
    endDate() {
      this.getMetrikaData()
    },
    '$attrs.site_key'() {
      this.$log.debug('changed', this.$attrs.site_key)
      this.getMetrikaData()
    },
  },
  async mounted() {
    this.$log.debug('mounted', this.$attrs.site_key)
    this.getMetrikaData()
  },
  methods: {
    getMetrikaData() {
      this.loading = true
      getSitesMetrikaResponse(this.axios, this.startDate, this.endDate, this.$attrs.site_key)
        .then((resp) => {
          this.metrikaData = resp.data
          this.chartData = this.getChartData()
        })
        .catch((e) => {
          this.showSnackbar(e, 'error')
        })
        .finally(() => (this.loading = false))
    },
    getChartData() {
      let datasets = []
      Object.values(this.metrikaData).forEach((x) => {
        const totalHits = this.currentDateRange.map((date) => {
          const val = x.dates[date.format('YYYY-MM-DD')]
          return val ? val.total_hits : 0
        })
        const uniqueUsers = this.currentDateRange.map((date) => {
          const val = x.dates[date.format('YYYY-MM-DD')]
          return val ? val.unique_user : 0
        })
        const uniqueIP = this.currentDateRange.map((date) => {
          const val = x.dates[date.format('YYYY-MM-DD')]
          return val ? val.unique_ip : 0
        })
        const backgroundColor = `rgba(2, 136, 209, 0.75)`
        this.$log.debug('backgroundColor', backgroundColor, colors.blueGrey.base)
        datasets.push({
          label: `Просмотры: в среднем ${average(totalHits)}`,
          data: totalHits,
          borderColor: backgroundColor,
          backgroundColor: `rgba(2,136,209,0.12)`,
          borderWidth: 3,
        })

        datasets.push({
          label: `Уникальные пользователи: в среднем ${average(uniqueUsers)}`,
          data: uniqueUsers,
          // borderColor: `rgba(230, 81, 0, 0.58)`,
          borderColor: `#8BC34A`,
          backgroundColor: `rgba(139, 195, 74, 0.12)`,
          borderWidth: 3,
        })

        datasets.push({
          label: `Уникальные IP: в среднем ${average(uniqueIP)}`,
          data: uniqueIP,
          // backgroundColor: `rgba(156, 204, 101, 0.6)`,
          borderColor: '#E53935',
          backgroundColor: 'rgba(229,57,53,0.12)',
          borderWidth: 3,
        })
      })
      return {
        labels: this.currentDateRange.map((x) => {
          return x.format('LL')
        }),
        datasets: datasets,
      }
    },
  },
}
</script>
